/** Maps Carecentre button variants to MUI Button props. */
export const CC_BUTTON_VARIANTS = {
  primary: { variant: "contained", color: "primary" },
  secondary: { variant: "outlined", color: "primary" },
  ghost: { variant: "text", color: "primary" },
  danger: { variant: "contained", color: "secondary" },
  dangerOutline: { variant: "outlined", color: "secondary" },
  ai: { variant: "contained", color: "secondary" },
};

export const CC_BUTTON_SIZES = {
  sm: "small",
  md: "medium",
  lg: "large",
};

/** danger / ai use contained + custom classes (see CcButton makeStyles). */
export const getMuiButtonProps = (variant = "primary", size = "md") => {
  if (variant === "danger" || variant === "ai") {
    return {
      variant: "contained",
      color: "primary",
      size: CC_BUTTON_SIZES[size] || "medium",
    };
  }

  const mapped = CC_BUTTON_VARIANTS[variant] || CC_BUTTON_VARIANTS.primary;

  return {
    ...mapped,
    size: CC_BUTTON_SIZES[size] || "medium",
  };
};
